var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "button",
      {
        class:
          "btn " + (_vm.montrerBarquettes ? "btn-primary" : "btn-secondary"),
        on: { click: _vm.toggleBarquettes }
      },
      [_vm._v("Barquettage")]
    ),
    _vm.montrerBarquettes
      ? _c(
          "div",
          {
            style: _vm.dropLeft ? "right:15px;" : "",
            attrs: { id: "barquettes" }
          },
          [
            _c(
              "table",
              { staticStyle: { "table-layout": "fixed", width: "300px" } },
              [
                _vm._m(0),
                _vm._m(1),
                _c(
                  "tbody",
                  _vm._l(_vm.barquettesSelection, function(
                    barquette,
                    iBarquette
                  ) {
                    return _c("tr", { key: iBarquette }, [
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: barquette.Selectionne,
                              expression: "barquette.Selectionne"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(barquette.Selectionne)
                              ? _vm._i(barquette.Selectionne, null) > -1
                              : barquette.Selectionne
                          },
                          on: {
                            change: function($event) {
                              var $$a = barquette.Selectionne,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      barquette,
                                      "Selectionne",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      barquette,
                                      "Selectionne",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(barquette, "Selectionne", $$c)
                              }
                            }
                          }
                        })
                      ]),
                      _c("td", [_vm._v(" " + _vm._s(barquette.Taille) + " ")]),
                      _c("td", [
                        _vm._v(" " + _vm._s(barquette.Designation) + " ")
                      ])
                    ])
                  }),
                  0
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "flex-end",
                staticStyle: { "padding-top": "5px" }
              },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn-primary",
                    attrs: { disabled: !_vm.modifBarquettes },
                    on: { click: _vm.enregistrerBarquettes }
                  },
                  [_vm._v("Valider")]
                )
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { span: "1", width: "42" } }),
      _c("col", { attrs: { span: "1", width: "52" } }),
      _c("col", { attrs: { span: "1", width: "202" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _c("th", [_vm._v("Taille")]),
        _c("th", [_vm._v("Désignation")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }